import React from "react";
import { MapPin, Phone, Instagram } from "lucide-react";

const WHATSAPP_URL = "https://wa.me/56975359774?text=" + encodeURIComponent("Hola, quiero personalizar una funda");
const MAPS_URL = "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent("Ossa Cerda 275, Galería Americano local 8, Caldera, Chile");
const INSTAGRAM_URL = "https://www.instagram.com/torviaccesorios.cl?igsh=ZzF2NGxuN2Y3cW1n";

export default function Contacto() {
  return (
    <section className="py-16 md:py-24 bg-white" data-testid="contacto-page">
      <div className="max-w-5xl mx-auto px-5 md:px-8">
        <div className="text-xs uppercase tracking-[0.25em] font-bold text-[#0EA5E9]">Contacto</div>
        <h1 className="font-heading font-black text-4xl md:text-5xl mt-2">Estamos para ayudarte</h1>
        <p className="text-slate-600 mt-3 max-w-2xl">¿Tienes una idea para tu funda? Visítanos en Caldera o escríbenos por cualquier red.</p>

        <div className="grid md:grid-cols-3 gap-4 mt-10">
          <ContactCard
            href={MAPS_URL}
            testId="contact-maps-btn"
            icon={<MapPin size={22} />}
            title="Visítanos"
            primary="Ossa Cerda 275"
            secondary="Galería Americano · Local 8 · Caldera"
            color="bg-sky-500"
            cta="Abrir en Google Maps"
          />
          <ContactCard
            href={WHATSAPP_URL}
            testId="contact-whatsapp-btn"
            icon={<i className="fa-brands fa-whatsapp text-2xl" />}
            title="WhatsApp"
            primary="+56 9 7535 9774"
            secondary="Respondemos al instante · Lun a Sáb"
            color="bg-emerald-500"
            cta="Escríbenos por WhatsApp"
          />
          <ContactCard
            href={INSTAGRAM_URL}
            testId="contact-instagram-btn"
            icon={<Instagram size={22} />}
            title="Instagram"
            primary="@torviaccesorios.cl"
            secondary="Mira nuestros últimos diseños"
            color="bg-gradient-to-br from-pink-500 via-fuchsia-500 to-amber-500"
            cta="Síguenos en Instagram"
          />
        </div>

        <div className="mt-10 bg-slate-50 border border-slate-200 rounded-3xl overflow-hidden">
          <iframe
            title="Torvi Accesorios — Caldera"
            src="https://www.google.com/maps?q=Ossa%20Cerda%20275%2C%20Caldera%2C%20Chile&output=embed"
            className="w-full h-72 md:h-96 border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
}

const ContactCard = ({ href, testId, icon, title, primary, secondary, color, cta }) => (
  <a
    href={href}
    target="_blank"
    rel="noopener noreferrer"
    data-testid={testId}
    className="group bg-white border border-slate-200 rounded-3xl p-6 hover:shadow-xl hover:-translate-y-1 transition-all duration-300 block"
  >
    <div className={`w-14 h-14 rounded-2xl ${color} text-white flex items-center justify-center shadow-lg`}>{icon}</div>
    <div className="mt-4 text-xs uppercase tracking-widest font-bold text-slate-500">{title}</div>
    <div className="font-heading font-black text-lg text-black mt-0.5 leading-tight">{primary}</div>
    <div className="text-sm text-slate-600 mt-1 leading-relaxed">{secondary}</div>
    <div className="mt-4 inline-flex items-center gap-1 text-sm font-bold text-[#0EA5E9] group-hover:gap-2 transition-all">
      {cta} <span aria-hidden>→</span>
    </div>
  </a>
);
